import { Vue, Component, Prop, Watch, Inject } from 'vue-property-decorator';
import uuid4 from 'uuid';
import style from './style.vue';
import { noop } from '@/util';
import miniPageLink from '@/views/components/linkForm/miniPage';

@Component({
  mixins: [style],
})
export default class WeiGroup extends Vue {
  @Prop({ default: () => { } })
  value: ItemObject;

  @Prop({ default: false })
  disabled: boolean;

  @Inject({ default: 2 })
  mode: number;

  @Prop()
  fromPage: number;

  uuid = uuid4();
  data: ItemObject = {};

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n;
    }
  }

  @Watch('data', { deep: true })
  watchData(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n;
    }
    this.$emit('input', this.data);
  }

  onDelTab(i) {
    if (this.data.desc.weiGroupList.length === 1) {
      this.$message.error('请至少保留一个多页橱窗！')
      return
    }
    this.$confirm('是否删除该橱窗?', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      type: 'warning',
    }).then((result) => {
      if (result === 'confirm') {
        this.data.desc.weiGroupList.splice(i, 1);
      }
    });
  }

  addWindow() {
    this.data.desc.weiGroupList.push({
      title: '',
      caseType: 4,
      pageId: null,
    });
  }

  choosePage(item) {
    const { code, sgId, siteId } = this.$route.params;
    miniPageLink.open({ sgId: +sgId, siteCodes: [code], mode: this.mode, siteId: +siteId }).then((result) => {
      item.pageId = result.id;
      item._pageName = result.name;
    }, noop);
  }

  render(h) {
    return (
      <div class="multi-window r-pa-20">
        <span class="tip">注：请先在微页面中配置好页面，然后将微页面与橱窗页绑定。拖动下面标题可进行橱窗页的排序。</span>
        <el-form class="r-mt-20" props={{ model: this.data }} ref="form" label-width="70px" label-position={'left'} disabled={this.disabled}>
          <draggable scroll={true} v-model={this.data.desc.weiGroupList} draggable={'.windown-content'} preventOnFilter={false} filter={'.window-title'} scroll-sensitivity={150} force-fallback={true}>
            {(this.data.desc.weiGroupList || []).map((item, i) => {
              return (
                <div class="windown-content" key={this.uuid + i}>
                  <i class=" el-icon-error delete" onClick={this.onDelTab.bind(this, i)} />
                  <el-form-item label="标题" class="window-title" prop={`desc.weiGroupList[${i}].title`} rules={[{ required: true, message: ' ', trigger: 'blur' }]}>
                    <el-input v-model={item.title} maxlength={8} />
                  </el-form-item>
                  <el-form-item label="微页面" prop={`desc.weiGroupList[${i}].pageId`} rules={[{ required: true, message: '请选择微页面', trigger: 'change' }]}>
                    <span class="r-mx-0 scopeSpan" onClick={() => this.choosePage(item)}>
                      {item.pageId ? item._pageName : '请选择'}
                    </span>
                  </el-form-item>
                </div>
              );
            })}
          </draggable>
        </el-form>
        <span class="add-window scopeSpan" onClick={() => this.addWindow()}>
          添加一个橱窗页
        </span>
      </div>
    );
  }
}
